import { TableType } from '@app/shared/tables/enums/table-type.enum';

export const DEFAULT_TABLE_SIZE = {
  [TableType.RemindersList]: 20,
  [TableType.GroupsCardsList]: 15,
  [TableType.GroupsAdministrationList]: 20,
  [TableType.TagsAdministrationList]: 20,
  [TableType.GroupMembersList]: 20,
  [TableType.GroupMessagesList]: 10,
  [TableType.TgUsersList]: 20,
};
